import { t } from "i18next";
console.log(t);
export const PAGE_URL = {
  LOGIN: "/login",
  SIGNUP: "/signup",
  FORGOT_PASSWORD: "/forgot-password",
  NEW_PASSWORD: "/new-password",
  KNOWLEDGE_BASE: "/knowledge-base",
  NO_ACCESS: "/not-authorized",
  // CHAT: "/chat",
  CONFIGURE_CHAT: "/settings/configure-assistant",
  SETTINGS: "/settings",
  INTEGRATION: "/settings/integration",
  WORKSPACE: "/settings/workspace",
  SEARCH_DOC: "/search-document",
  USERS: "/settings/users",
  CONFIGURE_ACTIONS: "/settings/configureactions",
  PROJECT: "/project",
  PROJECT_DETAIL: "/project/:projectId/view",
  BILLINGS_AND_PLANS: "/settings/billings",
  INSIGHTS: "/insights",
  FORMBUILDER: "/settings/formbuilder",
  FORMBUILDER2: "/settings/formbuilder2",
  CREATE_FORMS: "/settings/formbuilder/select",
  CREATE_FORM: "/settings/formbuilder/:formType/create",
  EDIT_FORMS: "/settings/formbuilder/:formType/:formId/edit",

  FORMS: "/forms",
  FORM_INSTANCE_VIEW: "/forms/:formId/view",
  FORM_INSTANCE_EDIT: "/forms/:formId/edit",

  FORMS_CREATE: "/forms/:formId/create",
  // FORMS_CREATE: "/forms/:id/work_permit/create",
  // FORMS_CUSTOM_CREATE: "/forms/:id/custom/create",
  //FORMS_INSPECTION_CREATE: "/forms/:id/inspection/creatE",
  FORMS_TEMPLATES: "/forms/templates",

  SUBSCRIPTION_BILLINGS: "/settings/upgradesubscription",
  WORKFLOW: "/workflows",
  RUN_WORKFLOW: "/workflows/runworkflow",
  EDIT_WORKFLOW: "/workflows/editworkflow",
  EXTERNAL_ASSISTANT: "/settings/assistants",
  CREATE_EXTERNAL_ASSISTANT: "/settings/assistants/create",
  UPDATE_ASSISTANT: "/settings/assistants/update",
  ASSITANT_CHAT: "/assistant-chat-history/chat",
  ASSITANT_CHAT_HISTORY: "/assistant-chat-history",
  SETTINGS_ASSITANT_CHAT: "/settings/assistants/chat",

  CHANGE_PASSWORD: "/change-password",
  PRIVACY_POLICY: "/privacy-policy",
  // PRICING: "/pricing",
  SUBSCRIPTION: "/subscription",
  REPORT: "/reports",
  REPORT_SELECTION_FORM300: "/reports/form300/select",

  FORM300: "/reports/form300",
  FORM300_CREATE: "/reports/form300/create",
  FORM300_EDIT: "/reports/form300/:form300Id/edit",
  FORM300_VIEW: "/reports/form300/:form300Id/view",
  REPORT_SELECTION_FORM301: "/reports/form301/select",
  FORM301: "/reports/form301",
  FORM301_CREATE: "/reports/form301/create",
  FORM301_EDIT: "/reports/form301/:form301Id/edit",
  FORM301_VIEW: "/reports/form301/:form301Id/view",
  REPORT_DASHBOARD: "/dashboard",
  CustomFormBuilder: "/forms",

  SERVICE_TYPE: "/settings/equipment-type",
  SERVICE_TYPE_CREATE: "/settings/equipment-type/create",
  SERVICE_TYPE_EDIT: "/settings/equipment-type/:id/edit",

  SERVICE_UNIT: "/equipments",
  SERVICE_UNIT_CREATE: "/equipments/create",
  SERVICE_UNIT_EDIT: "/equipments/:serviceUnitId/edit",
  SERVICE_UNIT_VIEW: "/equipments/:serviceUnitId/view",
  SERVICE_UNIT_INSPECTION_EDIT: "/equipments/:id/inspection/:formId/edit",
  SERVICE_UNIT_INSPECTION_CREATE: "/equipments/:id/inspection/:formId/create",
  AUDIT: "/reports/:id/audits",

  EMPLOYEES: "/employee",
  EMPLOYEE_VIEW: "/employee/:empId/view",

  TRAINING: "/settings/training",

  FORMS_VIDEO_TRANSCRIPTION: "/forms/:auditId", //create
  AUDIT_VIDEO_TRANSCRIPTION: "/reports/:id/audits/:auditId", //create
  AUDIT_INSPECTION_EDIT: "/reports/:id/audit/:formId/edit",
  AUDIT_INSPECTION_CREATE: "/reports/:id/audit/:formId/create",
};

export const PAGE_TITLE = [
  { path: "/knowledge-base", title: "Knowledge Base" },
  { path: "/reports", title: "Incident Reports" },

  // { path: "/reports", title: t("reports") },

  // { path: "/reports/form301", title: "Form 301 History" },

  {
    path: "/reports/form300",
    title: "Form300 History",
    breadcrumb: [
      { path: "/reports", title: "Incident Reports" },
      { path: "", title: "Form300 History" },
    ],
  },
  {
    path: "/reports/form301",
    title: "Form301 History",
    breadcrumb: [
      { path: "/reports", title: "Incident Reports" },
      { path: "", title: "Form301 History" },
    ],
  },
  {
    path: "/reports/form300/select",
    title: "Select",
    breadcrumb: [
      { path: "/reports", title: "Incident Reports" },
      { path: "/reports/form300", title: "Form300" },
      { path: "", title: "Select" },
    ],
  },
  {
    path: "/reports/form301/select",
    title: "Select",
    breadcrumb: [
      { path: "/reports", title: "Incident Reports" },
      { path: "/reports/form301", title: "Form301" },
      { path: "", title: "Select" },
    ],
  },
  {
    path: "/reports/form300/create",
    title: "Create",
    breadcrumb: [
      { path: "/reports", title: "Incident Reports" },
      { path: "/reports/form300", title: "Form300" },
      { path: "", title: "Create" },
    ],
  },
  {
    path: "/reports/form301/create",
    title: "Create",
    breadcrumb: [
      { path: "/reports", title: "Incident Reports" },
      { path: "/reports/form301", title: "Form301" },
      { path: "", title: "Create" },
    ],
  },
  {
    path: "/reports/form300/:form300Id/edit",
    title: "Edit",
    breadcrumb: [
      { path: "/reports", title: "Incident Reports" },
      { path: "/reports/form300", title: "Form300" },
      { path: "", title: "Edit" },
    ],
  },
  {
    path: "/reports/form301/:form301Id/edit",
    title: "Create",
    breadcrumb: [
      { path: "/reports", title: "Incident Reports" },
      { path: "/reports/form301", title: "Form301" },
      { path: "", title: "Edit" },
    ],
  },

  { path: "/workflows", title: "Workflows" },
  {
    path: "/workflows/runworkflow",
    title: "Run Workflow",
    breadcrumb: [
      { path: "/workflows", title: "Workflows" },
      { path: "", title: "Run Workflow" },
    ],
  },
  {
    path: "/workflows/editworkflow",
    title: "Edit Workflow",
    breadcrumb: [
      { path: "/workflows", title: "Workflows" },
      { path: "", title: "Edit Workflow" },
    ],
  },
  // { path: "/chat", title: "Chat" },
  {
    path: "/settings/configure-assistant",
    title: "External Assistant",
    breadcrumb: [
      { path: "/settings", title: "Settings" },
      { path: "", title: "External Assistant" },
    ],
  },
  {
    path: "/settings/formbuilder",
    title: "Forms",
    breadcrumb: [
      { path: "/settings", title: "Settings" },
      { path: "", title: "Templates" },
    ],
  },
  {
    path: "/settings/formbuilder/select",
    breadcrumb: [
      { path: "/settings", title: "Settings" },
      { path: "/settings/formbuilder", title: "Templates" },
      { path: "", title: "Create" },
    ],
  },
  {
    path: "/settings/formbuilder/:formType/create",
    breadcrumb: [
      { path: "/settings", title: "Settings" },
      { path: "/settings/formbuilder", title: "Templates" },
      { path: "", title: "Create" },
    ],
  },
  {
    path: "/settings/formbuilder/:formType/:formId/edit",
    breadcrumb: [
      { path: "/settings", title: "Settings" },
      { path: "/settings/formbuilder", title: "Templates" },
      { path: "", title: "Update" },
    ],
  },
  { path: "/settings", title: "Settings" },
  { path: "/search-document", title: "Search Documents" },
  {
    path: "/settings/integration",
    title: "Integration",
    breadcrumb: [
      { path: "/settings", title: "Settings" },
      { path: "", title: "Integration" },
    ],
  },
  {
    path: "/settings/workspace",
    breadcrumb: [
      { path: "/settings", title: "Settings" },
      { path: "", title: "Workspace" },
    ],
  },
  {
    path: "/settings/assistants",
    breadcrumb: [
      { path: "/settings", title: "Settings" },
      { path: "", title: "Assistants" },
    ],
  },
  {
    path: "/settings/users",
    breadcrumb: [
      { path: "/settings", title: "Settings" },
      { path: "", title: "Users" },
    ],
  },
  {
    path: "/settings/assistants/create",
    breadcrumb: [
      { path: "/settings", title: "Settings" },
      { path: "/settings/assistants", title: "Assistants" },
      { path: "", title: "Create" },
    ],
  },
  {
    path: "/settings/assistants/update",
    breadcrumb: [
      { path: "/settings", title: "Settings" },
      { path: "/settings/assistants", title: "Assistants" },
      { path: "", title: "Update" },
    ],
  },
  {
    path: "/settings/configureactions",
    breadcrumb: [
      { path: "/settings", title: "Settings" },
      { path: "", title: "Configure Actions" },
    ],
  },
  {
    path: "/project",
    // breadcrumb: [
    //   { path: "/project", title: "Projects" },
    //   // { path: "", title: "Project" },
    // ],
    title: "Sites",
  },
  {
    path: "/project/:projectId/view",
    breadcrumb: [
      { path: "/project", title: "Sites" },
      { path: "", title: "" },
    ],
  },
  {
    path: "/settings/billings",
    breadcrumb: [
      { path: "/settings", title: "Settings" },
      { path: "", title: "Billings & Plans" },
    ],
  },
  {
    path: "/settings/upgradesubscription",
    breadcrumb: [
      { path: "/settings", title: "Settings" },
      { path: "", title: "Subscription & Billings" },
    ],
  },
  {
    path: "/assistants",
    title: "Assistants",
  },
  {
    path: "/assistants/create",
    breadcrumb: [
      { path: "/assistants", title: "Assistants" },
      { path: "", title: "Create Assistant" },
    ],
  },
  {
    path: "/assistants/update",
    breadcrumb: [
      { path: "/assistants", title: "Assistants" },
      { path: "", title: "Update Assistant" },
    ],
  },
  { path: "/assistant-chat", title: t("assistantChat") },
  { path: "/assistant-chat-history", title: "Assistant Chats" },
  {
    path: "/assistant-chat-history/chat",
    breadcrumb: [
      { path: "/assistant-chat-history", title: "Assistant Chats" },
      { path: "", title: "chat" },
    ],
  },
  {
    path: "/settings/assistants/chat",
    breadcrumb: [
      { path: "/settings", title: "Settings" },
      { path: "/settings/assistants", title: "Assistants" },
      { path: "", title: "chat" },
    ],
  },

  { path: "/dashboard", title: "Dashboard" },
  { path: "/insights", title: "Insights" },
  { path: "/forms", title: "Forms" },
  {
    path: "/forms/templates",
    breadcrumb: [
      { path: "/forms", title: "Forms" },
      { path: "", title: "Templates" },
    ],
  },
  {
    path: "/forms/:id/create",
    breadcrumb: [
      { path: "/forms", title: "Forms" },

      { path: "", title: "Create" },
    ],
  },
  {
    path: "/forms/:formId/view",
    breadcrumb: [
      { path: "/forms", title: "Forms" },
      { path: "", title: "View" },
    ],
  },
  {
    path: "/forms/:formId/edit",
    breadcrumb: [
      { path: "/forms", title: "Forms" },
      { path: "", title: "Edit" },
    ],
  },
  {
    path: "/forms/:auditId",
    breadcrumb: [
      { path: "/forms", title: "Forms" },
      { path: "", title: "" },
    ],
  },

  {
    path: "/settings/equipment-type",
    breadcrumb: [
      { path: "/settings", title: "Settings" },
      { path: "", title: "Equipments Type" },
    ],
  },
  {
    path: "/settings/equipment-type/create",
    breadcrumb: [
      { path: "/settings", title: "Settings" },
      { path: "/settings/equipment-type", title: "Equipments Type" },
      { path: "", title: "Create" },
    ],
  },
  {
    path: "/settings/equipment-type/:id/edit",
    breadcrumb: [
      { path: "/settings", title: "Settings" },
      { path: "/settings/equipment-type", title: "Equipments Type" },
      { path: "", title: "Edit" },
    ],
  },
  {
    path: "/equipments",
    title: "Equipments",
  },
  {
    path: "/equipments/create",
    breadcrumb: [
      { path: "/equipments", title: "Equipments" },

      { path: "", title: "Create" },
    ],
  },
  {
    path: "/equipments/:id/edit",
    breadcrumb: [
      { path: "/equipments", title: "Equipments" },

      { path: "", title: "Edit" },
    ],
  },
  {
    path: "/equipments/:id/view",
    breadcrumb: [
      { path: "/equipments", title: "Equipments" },

      { path: "", title: "" },
    ],
  },
  {
    path: "/employee/:empId/view",
    breadcrumb: [
      { path: "/employee", title: "Employees" },

      { path: "", title: "" },
    ],
  },

  {
    path: "/reports/:id/audits",
    breadcrumb: [
      { path: "/reports", title: "Incident Reports" },

      { path: "", title: "Audits" },
    ],
  },
  {
    path: "/reports/:id/audits/:auditId",
    breadcrumb: [
      { path: "/reports", title: "Incident Reports" },
      { path: "/reports/:id/audits", title: "Audits", isDynamicPath: true },
      { path: "", title: "" },
    ],
  },
  {
    path: "/reports/:id/audit/:formId/edit",
    breadcrumb: [
      { path: "/reports", title: "Incident Reports" },
      { path: "/reports/:id/audits", title: "Audits", isDynamicPath: true },
      { path: "", title: "" },
    ],
  },
  {
    path: "reports/:id/audit/:formId/create",
    breadcrumb: [
      { path: "/reports", title: "Incident Reports" },
      { path: "/reports/:id/audits", title: "Audits", isDynamicPath: true },
      { path: "", title: "" },
    ],
  },
  {
    path: "equipments/:id/inspection/:formId/create",
    breadcrumb: [
      { path: "/equipments", title: "Equipments" },
      {
        path: "/equipments/:id/view",
        title: "Inspections",
        isDynamicPath: true,
      },
      { path: "", title: "" },
    ],
  },
  {
    path: "equipments/:id/inspection/:formId/edit",
    breadcrumb: [
      { path: "/equipments", title: "equipments" },
      {
        path: "/equipments/:id/view",
        title: "Inspections",
        isDynamicPath: true,
      },
      { path: "", title: "" },
    ],
  },

  {
    path: "/employee",
    title: "Employees",
  },

  {
    path: "/settings/training",
    breadcrumb: [
      { path: "/settings", title: "Settings" },
      { path: "", title: "Training" },
    ],
  },
  // {
  //   path: "/settings/service-type/create",
  //   breadcrumb: [
  //     { path: "/settings", title: "Settings" },
  //     { path: "/settings/service-type", title: "Service Unit Type" },
  //     { path: "", title: "Create" },
  //   ],
  // },
  // {
  //   path: "/settings/service-type/:id/edit",
  //   breadcrumb: [
  //     { path: "/settings", title: "Settings" },
  //     { path: "/settings/service-type", title: "Service Unit Type" },
  //     { path: "", title: "Edit" },
  //   ],
  // },
];
